const STEPS = [
  {
    no: "01",
    title: "Quote in 30 seconds",
    body:
      "Send us your address and a photo if you have one. A written estimate hits your phone in under 30 minutes.",
  },
  {
    no: "02",
    title: "Walk-through & prep",
    body:
      "Pre-wash inspection, landscape protection, calibrated detergent mix. Nothing is left to assumption.",
  },
  {
    no: "03",
    title: "Soft-wash & restore",
    body:
      "Surface-safe pressures, hot-water rinses where it matters. We work clean and we work quiet.",
  },
  {
    no: "04",
    title: "Final walk & guarantee",
    body:
      "We walk it with you. If we missed a spot, we’re back the next morning — at our cost.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative bg-[#09090B] py-24 sm:py-32 lg:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-16 sm:mb-20">
          <p className="font-mono-small text-[#E5D0A1] mb-6">— How It Works</p>
          <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] leading-[1.02]">
            Four steps.
            <br />
            <span className="font-editorial italic text-white/60 font-normal">
              No surprises.
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {STEPS.map((s, i) => (
            <div
              key={s.no}
              data-testid={`process-step-${i}`}
              className="bg-[#0d0d10] p-8 lg:p-10 flex flex-col gap-8 min-h-[280px]"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono-small text-[#E5D0A1]">{s.no}</span>
                <span className="w-8 h-px bg-white/20" />
              </div>
              <div>
                <h3 className="font-display text-white text-2xl tracking-tight mb-3">
                  {s.title}
                </h3>
                <p
                  className="font-body text-white/55 text-sm leading-relaxed"
                >
                  {s.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
